var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPingdom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 282 282",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.169231, 0, 0, 2.169231, 0, 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 130,
    rx: 65,
    width: 130,
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    fill: "#fff000",
    fillRule: "evenodd",
    style: {}
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 66.933 67.227 C 62.444 67.234 58.8 63.592 58.793 59.093 C 58.786 54.594 62.42 50.941 66.909 50.934 C 71.397 50.928 75.042 54.569 75.048 59.068 C 75.055 63.568 71.422 67.22 66.933 67.227 Z M 66.933 42.048 C 57.596 42.081 50.033 49.661 50 59.02 L 50 83.265 C 50 84.85 50.844 86.315 52.213 87.107 C 53.583 87.9 55.27 87.9 56.64 87.107 C 58.01 86.315 58.853 84.85 58.853 83.265 L 58.853 73.979 C 61.341 75.345 64.133 76.058 66.969 76.052 C 76.351 76.052 83.956 68.429 83.956 59.026 C 83.956 49.623 76.351 42 66.969 42 Z",
    fill: "#181818"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPingdom);
export default __webpack_public_path__ + "static/media/Pingdom.072f5611edfa58792efbf8d9fb10e147.svg";
export { ForwardRef as ReactComponent };